/* Recent-purchase toast. Shown on every storefront page. */
(function () {
  var STORAGE_KEY = 'qalzyPurchaseToastDismissed';
  var IMAGES = [
    'https://cdn.shopify.com/s/files/1/0795/8881/9222/files/11_Kitchen_scales_type_1_2_1.png?v=1774028564',
    'https://cdn.shopify.com/s/files/1/0795/8881/9222/files/12_Kitchen_scales_type_1_black_without_background.webp?v=1791282705'
  ];
  var FIRST_DELAY_MS = 10000;
  var VISIBLE_MS = 3000;
  var MOTION_MS = 320;

  if (window.__qalzyPurchaseToast) return;
  window.__qalzyPurchaseToast = true;

  try {
    if (window.sessionStorage.getItem(STORAGE_KEY) === '1') return;
  } catch (error) {}

  var notices = [
    { state: 'Alaska', minutes: 10 },
    { state: 'Nebraska', minutes: 5 },
    { state: 'Texas', minutes: 8 },
    { state: 'California', minutes: 3 },
    { state: 'Florida', minutes: 12 },
    { state: 'New York', minutes: 6 },
    { state: 'Colorado', minutes: 15 },
    { state: 'Arizona', minutes: 4 },
    { state: 'Georgia', minutes: 9 },
    { state: 'Illinois', minutes: 7 },
    { state: 'Ohio', minutes: 11 },
    { state: 'Washington', minutes: 14 },
    { state: 'Oregon', minutes: 2 },
    { state: 'Michigan', minutes: 18 },
    { state: 'Virginia', minutes: 13 },
    { state: 'North Carolina', minutes: 16 }
  ];

  var order = [];
  var index = 0;
  var imageIndex = 0;
  var lastState = '';
  var dismissed = false;
  var hideTimer = 0;
  var gapTimer = 0;

  function shuffle(list) {
    var copy = list.slice();
    for (var i = copy.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var current = copy[i];
      copy[i] = copy[j];
      copy[j] = current;
    }
    return copy;
  }

  function nextNotice() {
    if (index >= order.length) {
      order = shuffle(notices);
      index = 0;
      if (order.length > 1 && order[0].state === lastState) {
        var first = order[0];
        order[0] = order[1];
        order[1] = first;
      }
    }
    var notice = order[index];
    index += 1;
    lastState = notice.state;
    return notice;
  }

  function timeLabel(minutes) {
    return minutes === 1 ? '1 minute ago' : minutes + ' minutes ago';
  }

  function randomGap() {
    return 25000 + Math.floor(Math.random() * 15001);
  }

  var toast = document.createElement('aside');
  toast.className = 'qalzy-purchase-toast';
  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');
  toast.setAttribute('aria-hidden', 'true');

  var photoWrap = document.createElement('div');
  photoWrap.className = 'qalzy-purchase-toast__photo-wrap';

  var photo = document.createElement('img');
  photo.className = 'qalzy-purchase-toast__photo';
  photo.alt = 'Qalzy scale';
  photo.src = IMAGES[0];
  photo.width = 64;
  photo.height = 64;

  IMAGES.forEach(function (src) {
    var preload = new Image();
    preload.src = src;
  });

  var body = document.createElement('div');
  body.className = 'qalzy-purchase-toast__body';

  var message = document.createElement('p');
  message.className = 'qalzy-purchase-toast__message';

  var time = document.createElement('p');
  time.className = 'qalzy-purchase-toast__time';

  var close = document.createElement('button');
  close.type = 'button';
  close.className = 'qalzy-purchase-toast__close';
  close.setAttribute('aria-label', 'Dismiss notification');
  close.innerHTML = '<svg viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M1 1l12 12M13 1L1 13" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

  body.appendChild(message);
  body.appendChild(time);
  photoWrap.appendChild(photo);
  toast.appendChild(photoWrap);
  toast.appendChild(body);
  toast.appendChild(close);

  function clearTimers() {
    window.clearTimeout(hideTimer);
    window.clearTimeout(gapTimer);
  }

  function hide(then) {
    toast.classList.remove('is-visible');
    window.setTimeout(function () {
      toast.setAttribute('aria-hidden', 'true');
      if (typeof then === 'function') then();
    }, MOTION_MS);
  }

  function show() {
    if (dismissed) return;
    var notice = nextNotice();
    photo.src = IMAGES[imageIndex % IMAGES.length];
    photo.classList.toggle('is-black', imageIndex % IMAGES.length === 1);
    imageIndex += 1;
    message.textContent = 'Someone in ' + notice.state + ', US just bought a Qalzy Scale';
    time.textContent = timeLabel(notice.minutes);
    toast.setAttribute('aria-hidden', 'false');
    window.requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });
    hideTimer = window.setTimeout(function () {
      hide(function () {
        if (dismissed) return;
        gapTimer = window.setTimeout(show, randomGap());
      });
    }, VISIBLE_MS);
  }

  function dismiss() {
    if (dismissed) return;
    dismissed = true;
    clearTimers();
    try {
      window.sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (error) {}
    hide(function () {
      if (toast.parentNode) toast.parentNode.removeChild(toast);
    });
  }

  close.addEventListener('click', dismiss);

  function mount() {
    if (!document.body || toast.parentNode) return;
    document.body.appendChild(toast);
    window.setTimeout(show, FIRST_DELAY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
})();
